<template>
  <div class="product-filter" :class="className"
    v-clickoutsidedatepicker="datePickerClose"
  >
    <div class="product-filter-button" id="datepicker">
      <div class="product-filter-button__title"
      >Date Range</div>
      <div class="product-filter-button__input--datepicker-track" @click="filterToggle(true)">
        <div class="product-filter-button__input--datepicker-item">
          <input type="text" class="product-filter-button__input product-filter-button__input--datepicker" disabled
          :value="displayFrom"
          >
        </div>
        <div class="product-filter-button__input--datepicker-item">
          <input type="text" class="product-filter-button__input product-filter-button__input--datepicker" disabled
          :value="displayTo"
          >
        </div>
        <div class="product-filter-button__input--datepicker-item">
          <i class="product-filter__icon"></i>
        </div>
      </div>
      <span class="product-filter__overlay"></span>
    </div>

    <div class="product-filter-drop product-filter-drop--date">
      <div class="product-filter-select-holder">
        <select class="product-filter-select"
          @change="dateRangeSelectChange($event.target.value)"
        >
          <option value="">Custom Date Range</option>
          <option
            :key="option"
            v-for="option in Object.keys(customDateRangeOptions)"
            :value="option"
          >{{ option }}</option>
        </select>
      </div>

      <div class="product-filter-picker">
        <div class="product-filter-picker-column product-filter-picker-column--start"
          v-if="pickerDateRange"
        >
          <input type="text" class="product-filter-picker__input product-filter-picker__input--start" disabled
            :value="'Starting: ' + dateDisplay(pickerDateRange.start)">
          <i class="product-filter__icon"></i>
        </div>
        <div class="product-filter-picker-column product-filter-picker-column--end"
          v-if="pickerDateRange"
        >
          <input type="text" class="product-filter-picker__input product-filter-picker__input--end" disabled
            :value="'Ending: ' + dateDisplay(pickerDateRange.end)">
          <i class="product-filter__icon"></i>
        </div>

        <div class="product-filter-calendar" id="calendar"></div>
      </div>

      <div class="product-filter-picker-options">
        <button type="button" id="datepicker-reset" class="product-filter-picker__button product-filter-picker__button--reset"
          @click.prevent="datePickerReset"
        >Reset</button>

        <button type="button" id="datepicker-apply" class="product-filter-picker__button product-filter-picker__button--apply"
          @click.prevent="datePickerApply"
        >Apply</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { helpers } from '@/mixins/helpers.js'

  import _findKey from 'lodash/findKey'
  import Kalendae from 'kalendae'
  import Moment from 'moment'
  import { extendMoment } from 'moment-range'

  const moment = extendMoment(Moment)

  export default {
    name: 'productDatePicker',
    mixins: [helpers],
    props: {
      className: {
        default: '',
        type: String
      },
      dateRange: {
        required: true,
        type: Object
      }
    },
    data () {
      return {
        calendar: '',
        customDateRangeOptions: {
          'Today': [moment().startOf('day'), moment().endOf('day')],
          'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
          'Last 7 days': [moment().subtract(7, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
          'Last 30 days': [moment().subtract(30, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
          'Last 90 days': [moment().subtract(90, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
          'Last month': [moment().subtract(1, 'month').startOf('month').startOf('day'), moment().subtract(1, 'month').endOf('month')],
          'Last year': [moment().subtract(1, 'year').startOf('year').startOf('day'), moment().subtract(1, 'year').endOf('year')],
          'Week to date': [moment().startOf('week').startOf('day'), moment().endOf('day')],
          'Month to date': [moment().startOf('month').startOf('day'), moment().endOf('day')],
          'Quarter to date': [moment().startOf('quarter').startOf('day'), moment().endOf('day')],
          'Year to date': [moment().startOf('year').startOf('day'), moment().endOf('day')]
        },
        dateRangeDefault: 'Last 7 days',
        displayFrom: '',
        displayTo: '',
        pickerDateRange: null
      }
    },
    methods: {
      dateDisplay (date) {
        return this.dateFormat(date, 'YYYY-MM-DD')
      },
      datePickerApply () {
        this.updateDisplay()
        this.$emit('datePickerDateChange', this.pickerDateRange)
        this.filterToggle('close')
      },
      datePickerClose () {
        if (this.getBreakpoint() >= 768) {
          this.filterToggle('close')
        }
      },
      datePickerInit () {
        let that = this

        this.calendar = new Kalendae('calendar', {
          direction: 'today-past',
          mode: 'range',
          months: 2,
          viewStartDate: moment(),
          blackout: function (date) {
            return date.isAfter(moment(), 'day') || date.isBefore(moment().subtract(2, 'year'), 'day')
          },
          subscribe: {
            change: function (date) {
              let dateArray = this.getSelectedAsDates()
              let end = typeof (dateArray[1]) !== 'undefined' ? dateArray[1] : dateArray[0]
              let start = dateArray[0]

              that.pickerDateRange = moment.range(
                moment(start).startOf('day'),
                moment(end).endOf('day')
              )

              that.dateRangeSelect().value = ''
              let option = _findKey(that.customDateRangeOptions, (dates) => {
                const [
                  start,
                  end
                ] = dates

                return start.isSame(that.pickerDateRange.start) && end.isSame(that.pickerDateRange.end)
              })
              if (option) {
                that.dateRangeSelect().value = option
              }
            }
          }
        })

        this.datePickerReset()
      },
      datePickerReset () {
        this.dateRangeSelectChange(this.dateRangeDefault)

        const {
          from,
          to
        } = this.getSelectedRange()

        this.displayFrom = from
        this.displayTo = to
      },
      dateRangeSelect () {
        let container = this.$el
        return container.querySelector('.product-filter-select')
      },
      dateRangeSelectChange (value) {
        if (value !== '') {
          let [start, end] = this.customDateRangeOptions[value]
          this.dateRangeSelect().value = value
          this.calendar.setSelected([start, end])
        }
      },
      filterToggle (toggle) {
        let activeClass = 'datepicker-active'
        let activeToggle = 'active-toggle'
        let container = this.$el
        let target = container.querySelector('.product-filter-drop')

        if (toggle === true) {
          if (container.classList.contains(activeToggle)) {
            container.classList.remove(activeToggle)

            if (this.getBreakpoint() < 768) {
              this.slideUp(target)
            } else {
              container.classList.remove(activeClass)
            }
          } else {
            container.classList.add(activeToggle)

            if (this.getBreakpoint() < 768) {
              this.slideDown(target)
            } else {
              container.classList.add(activeClass)
            }
          }
        } else {
          if (toggle === 'close') {
            if (container.classList.contains(activeToggle)) {
              container.classList.remove(activeToggle)

              if (this.getBreakpoint() < 768) {
                this.slideUp(target)
              }
            }

            if (this.getBreakpoint() >= 768) {
              container.classList.remove(activeClass)
            }
          }

          if (toggle === 'open') {
            if (!container.classList.contains(activeToggle)) {
              container.classList.add(activeToggle)

              if (this.getBreakpoint() < 768) {
                this.slideDown(target)
              }
            }

            if (this.getBreakpoint() >= 768) {
              container.classList.add(activeClass)
            }
          }
        }
      },
      updateDisplay () {
        const {
          from,
          to
        } = this.getSelectedRange()

        this.displayFrom = from
        this.displayTo = to
      },
      getSelectedRange () {
        const dateFormat = 'MMM Do, YYYY'

        let [
          from,
          to
        ] = this.calendar.getSelectedRaw()

        from = from.format(dateFormat)
        to = to ? to.format(dateFormat) : from

        return {
          from,
          to
        }
      }
    },
    mounted () {
      this.datePickerInit()
    },
    directives: {
      clickoutsidedatepicker: {
        bind (el, binding, vnode) {
          el['@clickoutsidedatepicker'] = e => {
            if (
              !el.contains(e.target) &&
              binding.expression &&
              vnode.context[binding.expression]
            ) {
              binding.value()
            }
          }
          document.addEventListener('click', el['@clickoutsidedatepicker'], true)
        },
        unbind (el) {
          document.removeEventListener('click', el['@clickoutsidedatepicker'], true)
        }
      }
    },
    watch: {
      dateRange () {
        this.pickerDateRange = this.dateRange
        this.calendar.setSelected([this.pickerDateRange.start, this.pickerDateRange.end])
        this.updateDisplay()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/js/components/ProductDatePicker.vue